import { render, staticRenderFns } from "./LogoHorizontal.vue?vue&type=template&id=99e8d1dc&scoped=true"
import script from "./LogoHorizontal.vue?vue&type=script&lang=js"
export * from "./LogoHorizontal.vue?vue&type=script&lang=js"
import style0 from "./LogoHorizontal.vue?vue&type=style&index=0&id=99e8d1dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e8d1dc",
  null
  
)

export default component.exports